import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    fontWeight: 600,
    minWidth: 100,
    textTransform: 'none',
  },
  dialogPaper: {
    height: { sm: 220, xs: 'auto' },
    maxHeight: '90vh',
    maxWidth: '800px',
    width: { sm: '80vw', xs: '90vw' },
  },
});

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  canContinue?: boolean; // Optional prop to control if the modal can continue
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = 'Confirm',
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  canContinue,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason !== 'backdropClick') {
          onCancel();
        }
      }}
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions className={classes.actions}>
        {canContinue && (
          <Button
            onClick={onCancel}
            className={classes.button}
            startIcon={<CloseIcon />}
          >
            {cancelText}
          </Button>
        )}
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          className={classes.button}
          startIcon={<CheckCircleIcon />}
        >
          {canContinue ? confirmText : 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
